<template>
  <div>
    <b-modal hide-footer id="new-teacher" size="xl" body-class="py-0" centered title="Agregar Docente"
      header-bg-variant="primary" header-text-variant="light" button-size="sm">
      <div class="p-0">
        <b-row>
          <b-col cols="2" :style="{ backgroundColor: 'var(--primary)' }">
            <b-iconstack font-scale="1" class="ml-1" title="Agregar">
              <b-icon variant="white" scale="7" stacked icon="plus" shift-h="10" shift-v="-150"></b-icon>
              <b-icon variant="white" scale="13" stacked icon="person-fill" shift-h="80" shift-v="-200"></b-icon>
            </b-iconstack>
          </b-col>
          <b-col class="pt-3 pl-4" :style="{ backgroundColor: 'var(--platinum-light)' }">
            <form ref=" form" @submit.prevent="OnSubmit" @reset="onReset" v-if="show">
              <b-row class="pb-1">
                <!--   Nombre y Apellido   -->
                <b-col>
                  <b-form-group id="inputLastName" label="Apellido" label-for="lastName-input" :state="state">
                    <b-form-input required id="lastName-input" v-model="form.lastName" type="text" :state="state" trim>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="inputName" label="Nombre" label-for="name-input" :state="state">
                    <b-form-input required id="name-input" v-model="form.name" type="text" :state="state" trim>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="hiringDate" label="Contratación" label-for="hiringDate-input">
                    <b-form-datepicker id="hiringDate-input" v-model="form.hiring_date" locale="es"></b-form-datepicker>
                  </b-form-group>
                </b-col>
              </b-row>
              <!--   Email y Rol   -->
              <b-row class="pb-2">
                <b-col>
                  <b-form-group id="emailInput" label="Email" label-for="email-input" :state="state">
                    <b-form-input required id="email-input" v-model="form.email" type="email" :state="state"
                      trim></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="roleInput" label="Rol:" label-for="teacher-roles-input">
                    <b-form-select id="teacher-roles-input" v-model="form.role" :options="teacherRoles"
                      required></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!--   Color   -->
              <b-row class="pb-2">
                <b-col cols="9">
                  <template>
                    <div class="form__field">
                      <div class="form__label">
                        <strong>Color:</strong>
                      </div>
                      <div class="form__input">
                        <v-swatches background-color="var(--platinum-light)" v-model="form.color" :swatches="swatches"
                          row-length="4" inline></v-swatches>
                      </div>
                    </div>
                  </template>
                </b-col>
                <b-col>
                  <p><strong>Color elegido: </strong></p>
                  <b-avatar v-if="form.color != ''" rounded="lg" :text="form.color"
                    :style="{ backgroundColor: form.color }" style="width: 150px; height: 80px"></b-avatar>
                  <b-avatar v-else rounded="lg" icon="question-lg"
                    style="background-color:#979595; width: 150px; height: 80px"></b-avatar>
                </b-col>
              </b-row>
              <!--   Firma   -->
              <b-form-group id="signatureInput" label="Agregar firma: " label-for="signature-input" :state="state">
              </b-form-group>
              <b-row class="pb-4">
                <b-col>
                  <div>
                    <b-form-file accept="image/jpeg, image/png, image/gif" v-model="signatureFileTemp"
                      placeholder="Elegir o arrastrar un archivo... " drop-placeholder="Drop file"></b-form-file>
                    <div class="py-3 float-right">
                      <span v-if="displayWarning" class="mr-3 text-danger"> Debe subir un archivo </span>
                      <b-button variant="success" class="mr-2" @click="uploadSignatureTemp()">
                        <b-icon icon="upload" aria-hidden="true" class="mr-2"></b-icon> Subir</b-button>
                      <b-button variant="danger" @click="removeTempSignature()">Eliminar</b-button>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <img v-if="signatureLoaded === true" :src="form.signature" height="100px" width="400px">
                  <img v-else src='../../assets/images/no_signature.png' height="100px" width="400px">
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-progress v-if="bar.status === true" :value="bar.value" :variant="bar.color" :max=100 show-progress
                    animated></b-progress>
                </b-col>
              </b-row>
              <!-- Form Buttons -->
              <div>
                <b-row class="py-3 float-right">
                  <!-- <b-col>
                    <b-button @click="$bvModal.show('new-teacher-success')" variant="primary">ToastText</b-button>
                  </b-col> -->
                  <b-col>
                    <b-button type="submit" variant="primary">Agregar</b-button>
                  </b-col>
                  <b-col>
                    <b-button type="reset" variant="outline-secondary">Resetear</b-button>
                  </b-col>
                  <b-col>
                    <b-button @click="$bvModal.hide('new-teacher')" variant="outline-danger">Cerrar</b-button>
                  </b-col>
                </b-row>
              </div>
            </form>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal hide-header-close no-close-on-esc no-close-on-backdrop hide-footer header-bg-variant="success"
      header-text-variant="light" id="new-teacher-success" size="m" centered title="Creación de Docente">
      <h6> Agregamos a {{ form.name }}! </h6>
      <p class="pb-2"> Recordá que {{ form.name }} puede acceder a la aplicación utilizando su email y la contraseña
        generada
        automáticamente </p>
      <b-button @click="hideSuccessModal()" variant="success">Listo!</b-button>

      <template #modal-footer="{ }">
      </template>
    </b-modal>
  </div>
</template>

<script>
import { UsersService } from '@/services/users.service'
import { TeacherService } from '@/services/teacher.service'
import { PartnerService } from '@/services/partners.service'
import { GroupsService } from '@/services/groups.service'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  name: 'new-teacher-modal',
  props: [],
  defaultSignatureImage: '../../assets/images/no_signature.png',
  components: { VSwatches }, // window['vue-swatches'] - from CDN
  data () {
    return {
      signatureFileTemp: null,
      signatureLoaded: false,
      swatches: [
        '', '#F64272', '#F493A7', '#B80087', '#F8524F',
        '#8b5aff', '#695E26', '#372772', '#D7331D',
        '#ffa51a', '#754306', '#55504E', '#202B31',
        '#5D4E46', '#8C7569', '#B09F96', '#5C5C5C',
        '#EB0E0A', '#257E3B', '#396A3A', '#AF4631',
        '#28777B', '#28657B', '#2B50AA', '#9CC4B2', '#06C6B9'
      ],
      teacherRoles: [
        { value: 'manager', text: 'Manager' },
        { value: 'coordinator', text: 'Coordinación' },
        { value: 'teacher', text: 'Docente' }
      ],
      form: {
        email: '',
        name: '',
        lastName: '',
        role: 'teacher',
        signature: null,
        color: '',
        hiring_date: ''
      },
      bar: {
        status: true,
        value: 20,
        color: 'primary'
      },
      state: null,
      displayWarning: false,
      show: true
    }
  },
  computed: {},
  methods: {
    async OnSubmit (event) {
      this.bar.status = true
      event.preventDefault()
      console.log('form result', this.form)
      console.log('user data: ', this.$store.state.user)
      // teacher creation
      const teacherName = this.form.name + ' ' + this.form.lastName
      const newTeacher = {
        display_name: teacherName,
        x_name: teacherName,
        x_color: this.form.color,
        x_signature: this.form.signature,
        x_email: this.form.email,
        x_job_title: this.form.role,
        x_active: true,
        x_hiring_date: this.form.hiring_date
      }
      try {
        const teacherId = await TeacherService.create(newTeacher)
        console.log('created: ', teacherId, ' body: ', newTeacher)
        if (teacherId) {
          this.bar.value = 40
          // new partner
          try {
            const newPartner = {
              name: teacherName,
              property_account_payable_id: 42,
              property_account_receivable_id: 6,
              x_neptuno_id: false
            }
            const partnerId = await PartnerService.create(newPartner)
            if (partnerId) {
              this.bar.value = 60
              try {
                // get groups
                const groupsIdsPromise = GroupsService.getGroupsToAddUser('Docentes')
                const groupsIds = await groupsIdsPromise // Wait for the promise to resolve
                if (groupsIds) {
                  console.log('groups found ', groupsIds)
                  try {
                    // user creation
                    this.bar.value = 80
                    const companyId = this.$store.state.user.currentUser.company_id[0]
                    const password = this.form.name.charAt(0).toLowerCase() + this.form.lastName.toLowerCase()
                    const newUser = {
                      name: teacherName,
                      email: this.form.email,
                      password: password,
                      display_name: teacherName,
                      employee: true,
                      function: this.form.role,
                      login: this.form.email,
                      groups_count: groupsIds.length,
                      property_account_payable_id: 42,
                      property_account_receivable_id: 6,
                      x_neptuno_id: false,
                      odoobot_state: 'not_initialized',
                      partner_id: partnerId,
                      notification_type: 'inbox',
                      groups_id: groupsIds,
                      company_ids: [companyId],
                      company_id: companyId,
                      // x_avatar: req.body.avatar,
                      x_teacher_id: teacherId
                    }
                    const userId = await UsersService.create(newUser)
                    console.log('usuario creado con éxito: ', userId)
                    if (userId) {
                      this.bar.value = 100
                      this.bar.variant = 'success'
                      this.$bvModal.show('new-teacher-success')
                    }
                  } catch (error) {
                    console.log('Error en la creación de usuario: ', error)
                  }
                }
              } catch (error) {
                console.log('error en la asignación de grupos: ', error)
              }
            }
            console.log('created: ', partnerId)
          } catch (error) {
            console.log('error en la creación de partner: ', error)
          }
        }
      } catch (error) {
        console.log('error en la creación de docente: ', error)
      }
    },
    resetData () {
      this.form = {
        email: '',
        lastName: '',
        name: '',
        role: null,
        color: '',
        signature: null
      }
      this.signatureLoaded = false
      this.displayWarning = false
    },
    hideSuccessModal () {
      this.resetData()
      this.bar.status = false
      this.$emit('updateTeachers')
      // close modals
      this.$bvModal.hide('new-teacher')
      this.$bvModal.hide('new-teacher-success')
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.resetData()
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async uploadSignatureTemp () {
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
      if (this.signatureFileTemp === null) {
        this.displayWarning = true
      } else this.displayWarning = false
      this.form.signature = await toBase64(this.signatureFileTemp)
      this.signatureLoaded = true
      // console.log(this.form.signature)
    },
    removeTempSignature () {
      this.signatureFileTemp = null
      this.signatureLoaded = false
    }
  }
}
</script>
